var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 224,
    viewBox: "0 0 169 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.001 52.0951C216.621 53.1696 217.225 54.2546 217.813 55.3497C216.746 54.6517 216.033 53.4576 216.001 52.0951Z",
    fill: "#60C2E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.099 24.4796C195.963 26.2288 197.771 28.0369 199.52 29.9008C198.844 31.1509 197.521 32 196 32C193.791 32 192 30.2091 192 28C192 26.4789 192.849 25.156 194.099 24.4796Z",
    fill: "#60C2E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.65 6.18707C169.745 6.77461 170.83 7.37866 171.905 7.99889C170.542 7.96709 169.348 7.25399 168.65 6.18707Z",
    fill: "#60C2E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0951 7.99889C53.1696 7.37866 54.2546 6.77461 55.3497 6.18707C54.6517 7.25399 53.4577 7.96709 52.0951 7.99889Z",
    fill: "#60C2E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4796 29.9008C26.2288 28.0369 28.0369 26.2288 29.9008 24.4796C31.1509 25.156 32 26.4789 32 28C32 30.2091 30.2091 32 28 32C26.4789 32 25.156 31.1509 24.4796 29.9008Z",
    fill: "#60C2E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18707 55.3497C6.77461 54.2546 7.37866 53.1696 7.99889 52.0951C7.96709 53.4577 7.25399 54.6517 6.18707 55.3497Z",
    fill: "#60C2E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.813 168.65C217.225 169.745 216.621 170.83 216.001 171.905C216.033 170.542 216.746 169.348 217.813 168.65Z",
    fill: "#60C2E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.52 194.099C198.844 192.849 197.521 192 196 192C193.791 192 192 193.791 192 196C192 197.521 192.849 198.844 194.099 199.52C195.963 197.771 197.771 195.963 199.52 194.099Z",
    fill: "#60C2E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M171.905 216.001C170.542 216.033 169.348 216.746 168.65 217.813C169.745 217.225 170.83 216.621 171.905 216.001Z",
    fill: "#60C2E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3497 217.813C54.6517 216.746 53.4576 216.033 52.0951 216.001C53.1696 216.621 54.2546 217.225 55.3497 217.813Z",
    fill: "#60C2E9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9008 199.52C31.1509 198.844 32 197.521 32 196C32 193.791 30.2091 192 28 192C26.4789 192 25.156 192.849 24.4796 194.099C26.2288 195.963 28.0369 197.771 29.9008 199.52Z",
    fill: "#60C2E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99889 171.905C7.96709 170.542 7.25399 169.348 6.18707 168.65C6.77461 169.745 7.37866 170.83 7.99889 171.905Z",
    fill: "#60C2E9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80 4C80 6.20914 78.2091 8 76 8C73.7909 8 72 6.20914 72 4C72 1.79086 73.7909 0 76 0C78.2091 0 80 1.79086 80 4Z",
    fill: "#60C2E9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104 4C104 6.20914 102.209 8 100 8C97.7909 8 96 6.20914 96 4C96 1.79086 97.7909 0 100 0C102.209 0 104 1.79086 104 4Z",
    fill: "#60C2E9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128 4C128 6.20914 126.209 8 124 8C121.791 8 120 6.20914 120 4C120 1.79086 121.791 0 124 0C126.209 0 128 1.79086 128 4Z",
    fill: "#60C2E9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152 4C152 6.20914 150.209 8 148 8C145.791 8 144 6.20914 144 4C144 1.79086 145.791 0 148 0C150.209 0 152 1.79086 152 4Z",
    fill: "#60C2E9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28C56 30.2091 54.2091 32 52 32C49.7909 32 48 30.2091 48 28C48 25.7909 49.7909 24 52 24C54.2091 24 56 25.7909 56 28Z",
    fill: "#60C2E9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80 28C80 30.2091 78.2091 32 76 32C73.7909 32 72 30.2091 72 28C72 25.7909 73.7909 24 76 24C78.2091 24 80 25.7909 80 28Z",
    fill: "#60C2E9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104 28C104 30.2091 102.209 32 100 32C97.7909 32 96 30.2091 96 28C96 25.7909 97.7909 24 100 24C102.209 24 104 25.7909 104 28Z",
    fill: "#60C2E9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128 28C128 30.2091 126.209 32 124 32C121.791 32 120 30.2091 120 28C120 25.7909 121.791 24 124 24C126.209 24 128 25.7909 128 28Z",
    fill: "#60C2E9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152 28C152 30.2091 150.209 32 148 32C145.791 32 144 30.2091 144 28C144 25.7909 145.791 24 148 24C150.209 24 152 25.7909 152 28Z",
    fill: "#60C2E9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M176 28C176 30.2091 174.209 32 172 32C169.791 32 168 30.2091 168 28C168 25.7909 169.791 24 172 24C174.209 24 176 25.7909 176 28Z",
    fill: "#60C2E9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52C32 54.2091 30.2091 56 28 56C25.7909 56 24 54.2091 24 52C24 49.7909 25.7909 48 28 48C30.2091 48 32 49.7909 32 52Z",
    fill: "#60C2E9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52C56 54.2091 54.2091 56 52 56C49.7909 56 48 54.2091 48 52C48 49.7909 49.7909 48 52 48C54.2091 48 56 49.7909 56 52Z",
    fill: "#60C2E9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52C80 54.2091 78.2091 56 76 56C73.7909 56 72 54.2091 72 52C72 49.7909 73.7909 48 76 48C78.2091 48 80 49.7909 80 52Z",
    fill: "#60C2E9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M104 52C104 54.2091 102.209 56 100 56C97.7909 56 96 54.2091 96 52C96 49.7909 97.7909 48 100 48C102.209 48 104 49.7909 104 52Z",
    fill: "#60C2E9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128 52C128 54.2091 126.209 56 124 56C121.791 56 120 54.2091 120 52C120 49.7909 121.791 48 124 48C126.209 48 128 49.7909 128 52Z",
    fill: "#60C2E9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M152 52C152 54.2091 150.209 56 148 56C145.791 56 144 54.2091 144 52C144 49.7909 145.791 48 148 48C150.209 48 152 49.7909 152 52Z",
    fill: "#60C2E9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M176 52C176 54.2091 174.209 56 172 56C169.791 56 168 54.2091 168 52C168 49.7909 169.791 48 172 48C174.209 48 176 49.7909 176 52Z",
    fill: "#60C2E9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M200 52C200 54.2091 198.209 56 196 56C193.791 56 192 54.2091 192 52C192 49.7909 193.791 48 196 48C198.209 48 200 49.7909 200 52Z",
    fill: "#60C2E9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8 76C8 78.2091 6.20914 80 4 80C1.79086 80 0 78.2091 0 76C0 73.7909 1.79086 72 4 72C6.20914 72 8 73.7909 8 76Z",
    fill: "#60C2E9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76C32 78.2091 30.2091 80 28 80C25.7909 80 24 78.2091 24 76C24 73.7909 25.7909 72 28 72C30.2091 72 32 73.7909 32 76Z",
    fill: "#60C2E9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76C56 78.2091 54.2091 80 52 80C49.7909 80 48 78.2091 48 76C48 73.7909 49.7909 72 52 72C54.2091 72 56 73.7909 56 76Z",
    fill: "#60C2E9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76C80 78.2091 78.2091 80 76 80C73.7909 80 72 78.2091 72 76C72 73.7909 73.7909 72 76 72C78.2091 72 80 73.7909 80 76Z",
    fill: "#60C2E9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M104 76C104 78.2091 102.209 80 100 80C97.7909 80 96 78.2091 96 76C96 73.7909 97.7909 72 100 72C102.209 72 104 73.7909 104 76Z",
    fill: "#60C2E9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M128 76C128 78.2091 126.209 80 124 80C121.791 80 120 78.2091 120 76C120 73.7909 121.791 72 124 72C126.209 72 128 73.7909 128 76Z",
    fill: "#60C2E9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152 76C152 78.2091 150.209 80 148 80C145.791 80 144 78.2091 144 76C144 73.7909 145.791 72 148 72C150.209 72 152 73.7909 152 76Z",
    fill: "#60C2E9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M176 76C176 78.2091 174.209 80 172 80C169.791 80 168 78.2091 168 76C168 73.7909 169.791 72 172 72C174.209 72 176 73.7909 176 76Z",
    fill: "#60C2E9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M200 76C200 78.2091 198.209 80 196 80C193.791 80 192 78.2091 192 76C192 73.7909 193.791 72 196 72C198.209 72 200 73.7909 200 76Z",
    fill: "#60C2E9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M224 76C224 78.2091 222.209 80 220 80C217.791 80 216 78.2091 216 76C216 73.7909 217.791 72 220 72C222.209 72 224 73.7909 224 76Z",
    fill: "#60C2E9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8 100C8 102.209 6.20914 104 4 104C1.79086 104 0 102.209 0 100C0 97.7909 1.79086 96 4 96C6.20914 96 8 97.7909 8 100Z",
    fill: "#60C2E9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M32 100C32 102.209 30.2091 104 28 104C25.7909 104 24 102.209 24 100C24 97.7909 25.7909 96 28 96C30.2091 96 32 97.7909 32 100Z",
    fill: "#60C2E9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M56 100C56 102.209 54.2091 104 52 104C49.7909 104 48 102.209 48 100C48 97.7909 49.7909 96 52 96C54.2091 96 56 97.7909 56 100Z",
    fill: "#60C2E9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M80 100C80 102.209 78.2091 104 76 104C73.7909 104 72 102.209 72 100C72 97.7909 73.7909 96 76 96C78.2091 96 80 97.7909 80 100Z",
    fill: "#60C2E9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M104 100C104 102.209 102.209 104 100 104C97.7909 104 96 102.209 96 100C96 97.7909 97.7909 96 100 96C102.209 96 104 97.7909 104 100Z",
    fill: "#60C2E9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M128 100C128 102.209 126.209 104 124 104C121.791 104 120 102.209 120 100C120 97.7909 121.791 96 124 96C126.209 96 128 97.7909 128 100Z",
    fill: "#60C2E9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M152 100C152 102.209 150.209 104 148 104C145.791 104 144 102.209 144 100C144 97.7909 145.791 96 148 96C150.209 96 152 97.7909 152 100Z",
    fill: "#60C2E9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M176 100C176 102.209 174.209 104 172 104C169.791 104 168 102.209 168 100C168 97.7909 169.791 96 172 96C174.209 96 176 97.7909 176 100Z",
    fill: "#60C2E9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M200 100C200 102.209 198.209 104 196 104C193.791 104 192 102.209 192 100C192 97.7909 193.791 96 196 96C198.209 96 200 97.7909 200 100Z",
    fill: "#60C2E9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M224 100C224 102.209 222.209 104 220 104C217.791 104 216 102.209 216 100C216 97.7909 217.791 96 220 96C222.209 96 224 97.7909 224 100Z",
    fill: "#60C2E9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8 124C8 126.209 6.20914 128 4 128C1.79086 128 0 126.209 0 124C0 121.791 1.79086 120 4 120C6.20914 120 8 121.791 8 124Z",
    fill: "#60C2E9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M32 124C32 126.209 30.2091 128 28 128C25.7909 128 24 126.209 24 124C24 121.791 25.7909 120 28 120C30.2091 120 32 121.791 32 124Z",
    fill: "#60C2E9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56 124C56 126.209 54.2091 128 52 128C49.7909 128 48 126.209 48 124C48 121.791 49.7909 120 52 120C54.2091 120 56 121.791 56 124Z",
    fill: "#60C2E9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M80 124C80 126.209 78.2091 128 76 128C73.7909 128 72 126.209 72 124C72 121.791 73.7909 120 76 120C78.2091 120 80 121.791 80 124Z",
    fill: "#60C2E9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M104 124C104 126.209 102.209 128 100 128C97.7909 128 96 126.209 96 124C96 121.791 97.7909 120 100 120C102.209 120 104 121.791 104 124Z",
    fill: "#60C2E9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M128 124C128 126.209 126.209 128 124 128C121.791 128 120 126.209 120 124C120 121.791 121.791 120 124 120C126.209 120 128 121.791 128 124Z",
    fill: "#60C2E9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M152 124C152 126.209 150.209 128 148 128C145.791 128 144 126.209 144 124C144 121.791 145.791 120 148 120C150.209 120 152 121.791 152 124Z",
    fill: "#60C2E9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M176 124C176 126.209 174.209 128 172 128C169.791 128 168 126.209 168 124C168 121.791 169.791 120 172 120C174.209 120 176 121.791 176 124Z",
    fill: "#60C2E9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M200 124C200 126.209 198.209 128 196 128C193.791 128 192 126.209 192 124C192 121.791 193.791 120 196 120C198.209 120 200 121.791 200 124Z",
    fill: "#60C2E9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M224 124C224 126.209 222.209 128 220 128C217.791 128 216 126.209 216 124C216 121.791 217.791 120 220 120C222.209 120 224 121.791 224 124Z",
    fill: "#60C2E9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8 148C8 150.209 6.20914 152 4 152C1.79086 152 0 150.209 0 148C0 145.791 1.79086 144 4 144C6.20914 144 8 145.791 8 148Z",
    fill: "#60C2E9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M32 148C32 150.209 30.2091 152 28 152C25.7909 152 24 150.209 24 148C24 145.791 25.7909 144 28 144C30.2091 144 32 145.791 32 148Z",
    fill: "#60C2E9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M56 148C56 150.209 54.2091 152 52 152C49.7909 152 48 150.209 48 148C48 145.791 49.7909 144 52 144C54.2091 144 56 145.791 56 148Z",
    fill: "#60C2E9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M80 148C80 150.209 78.2091 152 76 152C73.7909 152 72 150.209 72 148C72 145.791 73.7909 144 76 144C78.2091 144 80 145.791 80 148Z",
    fill: "#60C2E9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M104 148C104 150.209 102.209 152 100 152C97.7909 152 96 150.209 96 148C96 145.791 97.7909 144 100 144C102.209 144 104 145.791 104 148Z",
    fill: "#60C2E9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M128 148C128 150.209 126.209 152 124 152C121.791 152 120 150.209 120 148C120 145.791 121.791 144 124 144C126.209 144 128 145.791 128 148Z",
    fill: "#60C2E9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M152 148C152 150.209 150.209 152 148 152C145.791 152 144 150.209 144 148C144 145.791 145.791 144 148 144C150.209 144 152 145.791 152 148Z",
    fill: "#60C2E9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M176 148C176 150.209 174.209 152 172 152C169.791 152 168 150.209 168 148C168 145.791 169.791 144 172 144C174.209 144 176 145.791 176 148Z",
    fill: "#60C2E9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M200 148C200 150.209 198.209 152 196 152C193.791 152 192 150.209 192 148C192 145.791 193.791 144 196 144C198.209 144 200 145.791 200 148Z",
    fill: "#60C2E9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M224 148C224 150.209 222.209 152 220 152C217.791 152 216 150.209 216 148C216 145.791 217.791 144 220 144C222.209 144 224 145.791 224 148Z",
    fill: "#60C2E9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M32 172C32 174.209 30.2091 176 28 176C25.7909 176 24 174.209 24 172C24 169.791 25.7909 168 28 168C30.2091 168 32 169.791 32 172Z",
    fill: "#60C2E9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M56 172C56 174.209 54.2091 176 52 176C49.7909 176 48 174.209 48 172C48 169.791 49.7909 168 52 168C54.2091 168 56 169.791 56 172Z",
    fill: "#60C2E9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M80 172C80 174.209 78.2091 176 76 176C73.7909 176 72 174.209 72 172C72 169.791 73.7909 168 76 168C78.2091 168 80 169.791 80 172Z",
    fill: "#60C2E9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M104 172C104 174.209 102.209 176 100 176C97.7909 176 96 174.209 96 172C96 169.791 97.7909 168 100 168C102.209 168 104 169.791 104 172Z",
    fill: "#60C2E9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M128 172C128 174.209 126.209 176 124 176C121.791 176 120 174.209 120 172C120 169.791 121.791 168 124 168C126.209 168 128 169.791 128 172Z",
    fill: "#60C2E9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M152 172C152 174.209 150.209 176 148 176C145.791 176 144 174.209 144 172C144 169.791 145.791 168 148 168C150.209 168 152 169.791 152 172Z",
    fill: "#60C2E9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M176 172C176 174.209 174.209 176 172 176C169.791 176 168 174.209 168 172C168 169.791 169.791 168 172 168C174.209 168 176 169.791 176 172Z",
    fill: "#60C2E9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M200 172C200 174.209 198.209 176 196 176C193.791 176 192 174.209 192 172C192 169.791 193.791 168 196 168C198.209 168 200 169.791 200 172Z",
    fill: "#60C2E9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M56 196C56 198.209 54.2091 200 52 200C49.7909 200 48 198.209 48 196C48 193.791 49.7909 192 52 192C54.2091 192 56 193.791 56 196Z",
    fill: "#60C2E9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M80 196C80 198.209 78.2091 200 76 200C73.7909 200 72 198.209 72 196C72 193.791 73.7909 192 76 192C78.2091 192 80 193.791 80 196Z",
    fill: "#60C2E9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M104 196C104 198.209 102.209 200 100 200C97.7909 200 96 198.209 96 196C96 193.791 97.7909 192 100 192C102.209 192 104 193.791 104 196Z",
    fill: "#60C2E9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M128 196C128 198.209 126.209 200 124 200C121.791 200 120 198.209 120 196C120 193.791 121.791 192 124 192C126.209 192 128 193.791 128 196Z",
    fill: "#60C2E9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M152 196C152 198.209 150.209 200 148 200C145.791 200 144 198.209 144 196C144 193.791 145.791 192 148 192C150.209 192 152 193.791 152 196Z",
    fill: "#60C2E9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M176 196C176 198.209 174.209 200 172 200C169.791 200 168 198.209 168 196C168 193.791 169.791 192 172 192C174.209 192 176 193.791 176 196Z",
    fill: "#60C2E9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M80 220C80 222.209 78.2091 224 76 224C73.7909 224 72 222.209 72 220C72 217.791 73.7909 216 76 216C78.2091 216 80 217.791 80 220Z",
    fill: "#60C2E9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M104 220C104 222.209 102.209 224 100 224C97.7909 224 96 222.209 96 220C96 217.791 97.7909 216 100 216C102.209 216 104 217.791 104 220Z",
    fill: "#60C2E9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M128 220C128 222.209 126.209 224 124 224C121.791 224 120 222.209 120 220C120 217.791 121.791 216 124 216C126.209 216 128 217.791 128 220Z",
    fill: "#60C2E9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M152 220C152 222.209 150.209 224 148 224C145.791 224 144 222.209 144 220C144 217.791 145.791 216 148 216C150.209 216 152 217.791 152 220Z",
    fill: "#60C2E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.825c400c09098a00bdea82e21b1ec38d.svg";
export { ForwardRef as ReactComponent };